export default __webpack_public_path__ + "static/media/performanceBlurredFbStats2.569e3812.png";